<template lang="pug">
  b-modal#roomMatch(
    ref="roomMatch"
    :title="$t('ui.room_match')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="xl"
    hide-footer
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-row
      .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
        b-pagination(size="sm" :total-rows="totalRowsRoomMatch" :per-page="perPageRoomMatch" v-model="currentPageRoomMatch" @input="getRoomMatchList")
      .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="perPageRoomMatch" @input="changedPageSizeRoomMatch")
      .col-sm-12.col-md-12.col-lg-12.col-xl-12
        b-table#tblList.table-sm.table-hover.table-bordered(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :items="roomMatchList" :fields="fields" thead-class="grey")
          template(v-slot:cell(index)="row")
            span {{ row.index + 1 }}
          template(v-slot:cell(working_date)="row")
            span {{ $moment(row.item.working_date).format("YYYY-MM-DD") }}
          template(v-slot:cell(match_time)="row")
            span {{ $moment(row.item.match_time).format("YYYY-MM-DD HH:mm:ss") }}
          template(v-slot:cell(market_type)="row")
            span {{ marketTypeList[row.item.market_type] }}
          template(v-slot:cell(sports_type)="row")
            span {{ mapSport(row.item.sports_type) }}
          template(v-slot:cell(match_status)="row")
            span {{ matchStatusList[row.item.match_status] }}
    .form-group
      b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}

</template>

<script>
export default {
  props: {
    roomId: ""
  },
  data() {
    return {
      loading: false,
      roomMatchList: [],
      submission: {
        success: true,
        status: ""
      },
      marketTypeList: {
        1: this.$t("ui.early"),
        2: this.$t("ui.today"),
        3: this.$t("ui.running")
      },
      matchStatusList: {
        0: this.$t("ui.active_reopen"),
        1: this.$t("ui.end"),
        2: this.$t("ui.cancel"),
        5: this.$t("ui.suspend")
      },
      currentPageRoomMatch: 1,
      totalRowsRoomMatch: 0,
      perPageRoomMatch: 10
    }
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "room_id",
          label: this.$t("ui.room_id"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "working_date",
          label: this.$t("ui.working_date"),
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "match_time",
          label: this.$t("ui.match_time"),
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "sports_type",
          label: this.$t("ui.sport"),
          thClass: "bg-grey",
          thStyle: {
            width: "6%"
          }
        },
        {
          key: "market_type",
          label: this.$t("ui.market_type"),
          thClass: "bg-grey",
          thStyle: {
            width: "8%"
          }
        },
        {
          key: "league_name",
          label: this.$t("ui.league"),
          thClass: "bg-grey",
          thStyle: {
            width: "17%"
          }
        },
        {
          key: "home_name_en",
          label: this.$t("ui.home"),
          thClass: "bg-grey",
          thStyle: {
            width: "14%"
          }
        },
        {
          key: "away_name_en",
          label: this.$t("ui.away"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "14%"
          }
        },
        {
          key: "match_status",
          label: this.$t("ui.match_status"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        }
      ];
    }
  },
  methods: {
    mapSport(sportsType) {
      if(sportsType == 1)
        return "Soccer"

      return;
    },
    changedPageSizeRoomMatch: function(pageSize) {
      this.perPageRoomMatch = pageSize;
      this.currentPageRoomMatch = 1
      this.getRoomMatchList()
    },
    done: function(evt) {
      evt.preventDefault()
      this.getRoomMatchList()
    },
		getRoomMatchList() {
      let room_id = this.roomId
      let page_number = this.currentPageRoomMatch;
      this.currentPageRoomMatch = parseInt(page_number);
      let page_size = this.perPageRoomMatch;
      this.$store
        .dispatch("user/getTournamentRoomMatchList", { room_id, page_number, page_size })
        .then(response => {
          if(response.success == true){
            this.roomMatchList = response.data
            this.totalRowsRoomMatch = response.data.length > 0 ? this.roomMatchList[0]["totalrows"] : 0;
          }
        })
        .catch(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.roomMatchList = []
      this.currentPageRoomMatch = 1
      this.totalRowsRoomMatch = 0
      this.perPageRoomMatch = 10
    },
    shown: function() {
      this.$nextTick(() => {
				this.getRoomMatchList()
      });
    },
    cancel: function() {
      this.$refs.roomMatch.hide()
    }
  }
};
</script>

